import React from "react";
import { Link } from "react-router-dom";

const Sidebar = () => {
  return (
    <>
      <div id="wrapper">
        <ul style={{background:"linear-gradient(180deg, #4edf8e 10%, #224abe 100%)"}}
          className="navbar-nav bg-gradient-primary sidebar sidebar-dark accordion toggled"
          id="accordionSidebar"
        >
          <Link
            className="sidebar-brand d-flex align-items-center justify-content-center mt-5 mb-4"
            to={"/painel"}
          >
            <img
              src="/img/sesc-logo-branca.png"
              width="90"
              height="75"
              className="rounded mx-auto d-block"
              alt="SESC"
            />
          </Link>
          <hr className="sidebar-divider my-0" />
       

          <li className="nav-item">
            <Link className="nav-link" to={"/gerencia-users"}>
              <i className="fas fa-table"></i>
              <span>Gerenciamento Clientela </span>
            </Link>
          </li>
         
          
          <hr className="sidebar-divider" />
        
          <li className="nav-item active ">
            <Link className="nav-link" to={"/dashboard"}>
              <i className="fas fa-user"></i>
              <span>Titulares em Aberto</span>
            </Link>
          </li>


            
          <li className="nav-item ">
            <Link className="nav-link" to={"/operador-titular"}>
              <i className="fas fa-user-cog"></i>
              <span>Titulares em Realizados</span>
            </Link>
          </li>
        
          <hr className="sidebar-divider d-none d-md-block" />
          
          
          <li className="nav-item active">
            <Link className="nav-link" to={"/pedidos-dep"}>
            <i className="fas fa-users"></i>
              <span>Dependentes em Aberto </span>
            </Link>
          </li>
          
           
          <li className="nav-item">
            <Link className="nav-link" to={"/operador-dep"}>
            <i className="fas fa-users-cog"></i>
              <span>Dependentes Realizados </span>
            </Link>
          </li>
          
          
          <div className="text-center d-none d-md-inline">
            <button
              className="rounded-circle border-0"
              id="sidebarToggle"
            ></button>
          </div>
        </ul>
      </div>
    </>
  );
};

export default Sidebar;
